import {
  CloseIcon,
  Description,
  Root,
  IconContainer,
  Title,
} from './ErrorPricesCard.ui';

export const ErrorCard = ({
  title,
  description,
  className,
}: {
  title: string;
  description: string;
  className?: string;
}) => (
  <Root className={className}>
    <IconContainer>
      <CloseIcon />
    </IconContainer>
    <Title>{title}</Title>
    <Description>{description}</Description>
  </Root>
);
